<div
    class="contract {{ hoverPack }}"
    [ngClass]="{ selected: selected || isSingleContract, 'bg-grey': contract.Disabled }"
    (click)="selectContract(contract)"
>
    <div class="flex-grow-1">
        <p class="contract-name" [ngClass]="colorPack" [title]="contract.Nickname">{{ contract.Nickname }}</p>
    </div>
    <div class="flex-grow-1">
        <span class="d-block h-auto">
            <p class="contract-customer">{{ contract.CustomerFirstName }} {{ contract.CustomerLastName }}</p>
        </span>
        <span class="d-block h-auto">
            <p class="small-text address">{{ address.toString() }}</p>
        </span>
    </div>
    <div class="flex-grow-1">
        <span class="energy-icon">
            <i class="{{ contract.getTypeProperties(contract.getType()).iconBop }}" [ngClass]="colorPack"  aria-hidden="true"></i>
        </span>
    </div>
</div>
